export interface IOrganizationKeySchema {
    id: string;
    name: string;
    value: string;
    webhookTrigger: boolean;
    ipWhitelist?: {
        value: string;
        enabled: boolean;
    }[];
    permissions: string[];
    createdAt: string;
    routingMatrix: boolean;
}
